module.exports = __webpack_public_path__ + "img/Packaging.982696d5.svg";